var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ allbnw: _vm.blackAndWhite },domProps:{"innerHTML":_vm._s(_vm.buildUpContent(_vm.detail))}})
}
var staticRenderFns = []

export { render, staticRenderFns }